export const ROOT = "/";

export const RATE_DETAIL_URL = "https://s20.si1.kabu.co.jp/Members/Trade/NFX/NF01101.asp";
